'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".Status-module_eddContainer__-t6GC{display:flex;margin:20px 0}.Status-module_clockIcon__ZLZv6{padding-top:.15rem}.Status-module_statusText__nIYni{line-height:1.25;margin-left:.375rem}";
var styles = {"eddContainer":"Status-module_eddContainer__-t6GC","clockIcon":"Status-module_clockIcon__ZLZv6","statusText":"Status-module_statusText__nIYni"};
styleInject["default"](css_248z, 'a79c80ce-4b05-4374-b432-a0740b55360f');

exports["default"] = styles;
